import { useState } from 'react';
import { useActions } from '../hooks/useActions';
import { RollbackButton } from '../components/RollbackButton';
import { ActionDiffPreview } from '../components/ActionDiffPreview';

export function ActionsPage() {
  const [page, setPage] = useState(1);
  const [expanded, setExpanded] = useState<string | null>(null);
  const { data, isLoading } = useActions({ page });

  return (
    <div className="space-y-4">
      <h2 className="text-xl font-semibold text-gray-900">Action Log</h2>

      {isLoading && <div className="text-center py-8 text-gray-500">Loading actions...</div>}

      {data?.actions && data.actions.length === 0 && (
        <div className="card p-6 text-center text-gray-500">No actions recorded yet.</div>
      )}

      {data?.actions && data.actions.length > 0 && (
        <div className="card overflow-hidden">
          <table className="w-full text-sm">
            <thead>
              <tr className="border-b border-gray-200 text-left text-gray-500 bg-gray-50">
                <th className="p-3 font-medium">Product</th>
                <th className="p-3 font-medium">Action</th>
                <th className="p-3 font-medium">Source</th>
                <th className="p-3 font-medium">Status</th>
                <th className="p-3 font-medium">Date</th>
                <th className="p-3 font-medium text-right">Rollback</th>
              </tr>
            </thead>
            <tbody>
              {data.actions.map((action) => (
                <tr key={action.id} className="border-b border-gray-100">
                  <td className="p-3">
                    <button
                      className="text-left hover:text-tailorcast-primary"
                      onClick={() => setExpanded(expanded === action.id ? null : action.id)}
                    >
                      {action.externalProductId}
                    </button>
                    {expanded === action.id && <ActionDiffPreview action={action} />}
                  </td>
                  <td className="p-3 text-gray-600 capitalize">
                    {action.actionType.replace(/_/g, ' ')}
                  </td>
                  <td className="p-3 text-gray-600">{action.source}</td>
                  <td className="p-3">
                    <span
                      className={`text-xs px-2 py-0.5 rounded-full font-medium ${
                        action.status === 'confirmed'
                          ? 'bg-green-100 text-green-800'
                          : action.status === 'failed'
                            ? 'bg-red-100 text-red-800'
                            : action.status === 'rolled_back'
                              ? 'bg-gray-100 text-gray-800'
                              : 'bg-yellow-100 text-yellow-800'
                      }`}
                    >
                      {action.status}
                    </span>
                  </td>
                  <td className="p-3 text-gray-400 text-xs">
                    {new Date(action.submittedAt).toLocaleDateString()}
                  </td>
                  <td className="p-3 text-right">
                    <RollbackButton action={action} />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {data && data.total > 20 && (
        <div className="flex items-center justify-center gap-2">
          <button
            onClick={() => setPage((p) => Math.max(1, p - 1))}
            disabled={page <= 1}
            className="btn btn-outline text-sm"
          >
            Previous
          </button>
          <span className="text-sm text-gray-600">Page {page}</span>
          <button
            onClick={() => setPage((p) => p + 1)}
            disabled={(data.actions?.length ?? 0) < 20}
            className="btn btn-outline text-sm"
          >
            Next
          </button>
        </div>
      )}
    </div>
  );
}
